import { useState } from 'react';
import { useApolloClient } from '@apollo/client/react';
import { Button } from '@repo/ui/Button';
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@repo/ui/Sheet';

import CreateApiKeyForAccount from './CreateApiKeyForAccount';
import GET_API_KEYS_FOR_ACCOUNT from '../gql/api_keys/getApiKeysForAccount.gql';

interface CreateApiKeySheetProps {
  accountId: string;
}

/** "Create API Key" button that opens the create form in a side panel. */
const CreateApiKeySheet = ({ accountId }: CreateApiKeySheetProps) => {
  const [open, setOpen] = useState(false);
  const client = useApolloClient();

  // Refresh the account's API key table, then close the panel
  const handleCreated = async () => {
    await client.refetchQueries({ include: [GET_API_KEYS_FOR_ACCOUNT] });
    setOpen(false);
  };

  return (
    <>
      <Button type="button" onClick={() => setOpen(true)}>
        Create API Key
      </Button>

      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="overflow-y-auto w-full sm:max-w-lg">
          <SheetHeader className="border-b border-border">
            <SheetTitle>Create API Key</SheetTitle>
          </SheetHeader>
          <div className="px-5 mt-6 w-full">
            {open && <CreateApiKeyForAccount accountId={accountId} onCreated={handleCreated} />}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
};

export default CreateApiKeySheet;
